// extracted by mini-css-extract-plugin
export default {"formWrapper":"LeadFunnelsBulkChangeManagerModal_formWrapper__IsYx8"};